export default class PermissionError extends Error {}
